import React from 'react'

function HoaResult() {
  return (
    <div className='text-center text-blue-600  text-3xl font-extrabold p-10'>
      Coming Soon...
    </div>
  )
}

export default HoaResult
